import { render, staticRenderFns } from "./OrderItemTile.vue?vue&type=template&id=264a33ea"
import script from "./OrderItemTile.vue?vue&type=script&lang=js"
export * from "./OrderItemTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports